
import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class Twitter {
  constructor($el, data) {
    this.$tweetContainer = null;
    this.$tweetContainer = $el.find('[data-twitter-tweets]');
    const username = $el.find('[data-twitter-username]').attr('data-twitter-username');
    const retweets = data.retweets;
    const images = data.images;

    this._fetchTweets(username, retweets, images);
  }

  _fetchTweets(username, retweets, images) {
    const config = {
      profile: { screenName: username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showImages: images,
      useEmoji: true,
      showRetweet: retweets,
      customCallback: tweets => this.renderTweets(tweets),
      showInteraction: false,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    this.$tweetContainer.html();

    if (tweets.length) {
      this.$tweetContainer.html($(tweets[0]));
    } else {
      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }
}
